import * as types from './mutation-types'
import ajax from '@/ajax'
import router from '@/router'
import store from '@/store'

export const getSessionUser = async ({ commit }) => {
    var body = {
        session_id: store.state.session_id
    }

    try {
        var fetch = await ajax.post('petugashaji/auth/session', body)
        var data = await fetch.data
        commit(types.SESSION_USER, data)
    } catch (err) {
        if (err.response) {
            if (err.response.status === 401) {
                logoutUser()
            }
        }
    }
}

export const checkSession = async () => {
    setInterval(async () => {
        try {
            var body = {
                session_id: store.state.session_id
            }
            var fetch = await ajax.post('petugashaji/auth/session', body)
        } catch (err) {
            if (err.response) {
                if (err.response.status === 401) {
                    logoutUser()
                }
            }
        }
    }, 3600000)
}

export const logoutUser = async () => {
    var body = {
        session_id: store.state.session_id
    }
    await ajax.post('petugashaji/auth/logout', body)

    localStorage.removeItem('api_token')
    localStorage.removeItem('session_id')
    localStorage.removeItem('role_id')
    store.state.api_token = ''
    store.state.session_id = ''
    store.state.role_id = ''
    
    router.push('/home')
}

export const saveBiodateUser = ({ commit }, biodataPayload) => {
    commit(types.BIODATA_USER, biodataPayload)
}

export const reNewApiToken = async ({ commit }) => {
    setInterval( async () => {
        try {
            var fetch = await ajax.post('petugashaji/auth/renew_token')
            var data = await fetch.data
            var token = 'Bearer ' + data.access_token

            commit(types.SET_API_TOKEN, token)
        } catch (error) {
            logoutUser()
        }
    }, 600000)
}

export const reNewSessionRedis = async ({ commit }) => {
    setInterval ( async () => {
        try {
            var body = {
                session_id: store.state.session_id
            }
            await ajax.post('petugashaji/auth/renew_session', body)
        } catch (error) {
            logoutUser()
        }
    }, 900000)
}

export const setRoleId = ({ commit }, roleIdPayload) => {
    commit(types.ROLE_ID, roleIdPayload)
}

export const setApiToken = ({ commit }, apiPayload) => {
    commit(types.SET_API_TOKEN, apiPayload)
}

export const setSessionId = ({ commit }, sessionIdPayload) => {
    commit(types.SET_SESSION_ID, sessionIdPayload)
}

export const getConfigDB = async () => {
    const getConfig = await ajax.post('petugashaji/master/app_config');
    const getDataConfig = await getConfig.data

    return getDataConfig
}


// WEBPACK FOOTER //
// ./src/store/actions.js